import React, { FunctionComponent, memo } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../../redux/store';
import BaseModal from '../base-modal';

/**
 * Generic modal wrapper with redux logic.
 * Use this globally.
 * Use dispatch() to change content within redux modal.
 * UI Kit
 */
const ReduxModal: FunctionComponent = () => {
  const { modalContent } = useSelector(
    (state: RootState) => state.modalHandler
  );
  return (
    <BaseModal
      canClickOutside={modalContent?.canClickOutside}
      className={modalContent?.backgroundColor}
      content={modalContent?.content}
      handleOnClose={modalContent?.onClose}
      isOpen={!!modalContent}
      modalClassName={modalContent?.modalClassName}
      step={modalContent?.step}
      steps={modalContent?.steps}
      title={modalContent?.title}
      titleIcon={modalContent?.titleIcon}
      titleIconFilled={modalContent?.titleIconFilled}
    />
  );
};

export default memo(ReduxModal);
